<template v-if="dbName" class="text-center">
    <div class="row gx-1 align-items-center">
        <div class="col-4 col-lg-2">
            <d-editable-select v-model="value[0]" :options="options" max-height="150" allow-clear="true"></d-editable-select>
        </div>
        <div class="col-auto">
            <input type="checkbox" v-model="bj"/>
            <label for="checkbox" @click="bj=!bj">滤去部分不可获取的技能</label>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto"> 选择状态： </div>
        <div class="col-4 col-sm-3 col-lg-2">
            <d-editable-select @click="queryList(dbName, 'states')" v-model="dataId[0]" :options="dataOptions" max-height="150" allow-clear="true"></d-editable-select>
        </div>
    </div>
    <div class="row gx-1 align-items-center">
        <div class="col-auto" v-if="valDisplay[value[0]]"> {{ op[value[0]] }} </div>
        <div class="col-3 col-sm-2" v-if="valDisplay[value[0]]">
            <input type="search" v-model="mulGte[value[0]]"
            @keyup.enter="query(0, type[value[0]], dbName, colList[type[value[0]]], code[value[0]], dataId[0], {'$lte':mulLte[value[0]]/100,'$gte':mulGte[value[0]]/100}, undefined, bj)" 
            class="form-control">
        </div>
        <div class="col-auto" v-if="valDisplay[value[0]]"> ~ </div>
        <div class="col-3 col-sm-2" v-if="valDisplay[value[0]]">
            <input type="search" v-model="mulLte[value[0]]"
            @keyup.enter="query(0, type[value[0]], dbName, colList[type[value[0]]], code[value[0]], dataId[0], {'$lte':mulLte[value[0]]/100,'$gte':mulGte[value[0]]/100}, undefined, bj)" 
            class="form-control">
        </div>
        <div class="col-auto" v-if="valDisplay[value[0]]"> % </div>

        <div class="col-auto">
            <button type="submit"
            @click="query(0, type[value[0]], dbName, colList[type[value[0]]], code[value[0]], dataId[0], {'$lte':mulLte[value[0]]/100,'$gte':mulGte[value[0]]/100}, undefined, bj)" 
            class="btn btn-primary">搜索</button>
        </div>
        <div class="col-auto align-self-end">
            <CButton color="primary" @click="visible[0] = !visible[0]" >折叠</CButton>
        </div>
    </div>
    <CCollapse :visible="visible[0]">
        <json-viewer
            :value="json[0]"
            :expand-depth=4
            :show-double-quotes="false"
            :show-array-index="false">
        </json-viewer>
    </CCollapse>
</template>
  
<script>
import axios from "@/utils/http"
import { CCollapse } from '@coreui/vue'
// import { CCard } from '@coreui/vue'
// import { CCardBody } from '@coreui/vue'
import { CButton } from '@coreui/vue'
import JsonViewer from 'vue-json-viewer'

export default {
    name: 'CommonQuery',
    components: {
        CCollapse, CButton,
        JsonViewer
    },
    data() {
        return {
            bj:false,
            options:[
                {'label': '攻击附加', 'value': 0},
                {'label': '直接附加', 'value': 1},
                {'label': '状态抗性', 'value': 2},
                {'label': '状态免疫', 'value': 3},
                {'label': '解除状态', 'value': 4},
            ],
            code:[32,21,13,14,22],
            type:['traits','effects','traits','traits','effects'],
            colList:{'traits':['actors','classes','weapons','armors','states','enemies'], 'effects':['skills','items']},
            dataId:[undefined,],
            valDisplay:[true,true,true,false,true],
            op:['+','','*','',''],
            visible: [false,false],
            json:[null,null],
            value:['','','','',''],
            addGte:[0,-9999,],
            addLte:[0,9999,],
            mulGte:[0,0,0,0,0],
            mulLte:[1000,1000,1000,1000,100],
            docList:null,
            dataOptions:[],
        }
    },
    props: ['dbName'],
    methods: {
        query(i, type, dbName, colList, code, dataId, value1, value2, availableBj){
            if(type == 'traits'){
                this.queryTraits(i, dbName, colList, code, dataId, value1)
            }else if(type == 'effects'){
                this.queryEffects(i, dbName, colList, code, dataId, value1, value2, availableBj)
            }
        },
        queryEffects(i, dbName, colList, code, dataId, value1, value2, availableBj){
            availableBj = this.bj  // 偷懒
            this.visible[i] = true
            axios.post('/' + dbName + '/others', { type:'effects', available:availableBj, colList: colList, code:code, dataId:dataId, value1:value1, value2:value2 })
                    .then(response => { this.json[i] = response.data })
        },
        queryTraits(i, dbName, colList, code, dataId, value){
            this.visible[i] = true
            axios.post('/' + dbName + '/others', { type:'traits', colList: colList, code:code, dataId:dataId, value:value })
                .then(response => { this.json[i] = response.data })
        },
        queryList(dbName, colName){
            if(this.docList == null){
                axios.post('/' + dbName + '/' + colName, { all: 1 })
                    // .then(response => { this.docList = [].concat(response.data) })
                    .then(response => {
                        this.docList = [].concat(response.data)
                        this.docList.forEach(doc => {
                            let id = doc['id'], name = doc['name'];
                            let label = String(id) + ': ' + name;
                            const maxLen = 10
                            if (label.length >= maxLen){
                                label = label.substring(0, maxLen) + "..."
                            }
                            let option = {'label': label, 'value': id,}
                            this.dataOptions.push(option)
                        });
                    })
            }
        },
    },
    created() {
    }
}
</script>
